export const FORM_ENTITY_USER_EVENT = 'formentityuserevent';
